export default __webpack_public_path__ + "static/desert-xs-5829b90678de1cedf7f6f28f82ba163f.webp";